import {
  CATALOG_TAG_LIST_SET_DATA,
  CATALOG_TAG_DETAIL_RESET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  list: null,
  paginateBy: 100,
  pageNumber: 1,
  lastPageNumber: 0,
  orderBy: 'asc',
  totalAuthorsCount: null,
};

const tagsList = (state = initialState, action) => {
  switch (action.type) {
    case CATALOG_TAG_LIST_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_TAG_DETAIL_RESET_DATA:
      return initialState;
    default:
      return state;
  }
};

export default tagsList;
